import React from 'react';
import Dialog from 'Components/Core/Dialog';
import Table from 'Components/Core/Table';
import './Menu.css';

const menuIcons = {
	'admin': 'bi-shield-lock',
	'logout': 'bi-box-arrow-right',
	'member-list': 'bi-people',
	'infos': 'bi-graph-up',
	'settings': 'bi-gear',
	'foren': 'bi-chat-square-text',
	'page-store': 'bi-file-earmark-text',
	'page-store-generator': 'bi-bookmark-star',
	'page-store-sections': 'bi-folder',
	'page-store-pages': 'bi-file-text',
	'smilies': 'bi-emoji-smile',
	'system-info': 'bi-info-circle',
	'topics': 'bi-tags',
	'forum-admin': 'bi-shield',
	'new-posting': 'bi-pencil-square',
	'unlock': 'bi-unlock',
	'hint': 'bi-megaphone',
	'php-info': 'bi-code-slash',
	'push-subscriptions': 'bi-bell',
	'forum-options': 'bi-sliders',
	'smilies-update': 'bi-arrow-clockwise',
	'software-update': 'bi-cloud-arrow-down',
	'termine': 'bi-calendar-event',
	'finanzkalender': 'bi-calendar-week',
	'dividendenrendite': 'bi-percent',
	'hauptversammlungen': 'bi-building',
	'dividendenkalender': 'bi-cash-coin',
	'insider': 'bi-eye',
	'shortpositions': 'bi-graph-down',
};

export default function Menu(props) {

	const x = props.x;

	x.wan.init(props.id);
	x.wan[props.id].show = show;
	x.wan[props.id].hide = hide;

	let currentId = '';
	let currentModule = '';

	const title = [];
	if (props.parentId === '') {
		title.push(<i key="header-left" className="bi bi-house table-icon" onClick={e => x.was.activateModule('forum')}></i>);
	}
	else {
		title.push(<i key="header-left" className="bi bi-arrow-left table-icon" onClick={e => x.was.activateNavigation(props.parentId)}></i>);
	}			
	title.push(<span key="header-title" >{props.title}</span>);
	title.push(<i key="header-right" className="bi bi-x-lg table-icon" onClick={e => x.wan[props.id].hide()}></i>);
	
	function hide() {
		x.wad[props.id].hide();
		x.wab.modal.hide();
	}

	function show() {
		x.wad[props.id].show();
		x.wab.modal.show();
	}

	return (
		<Dialog id={props.id} x={x} display="d-none" classes="no-modal dialog-menu" title={props.title}>
			<Table
				id={props.id + '-table'}
				x={x}
				dialogId={props.id}
				loadTable="1"
				module={props.module}
				listTask={props.listTask}
				deleteTask={props.deleteTask}
				classes="table-menu"
				noTitle={false}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'id':
							currentId = value;
							return false;
						case 'module':
							currentModule = value;
							return false;
						case 'title':
							if (currentId === '__menu-divider__') return null;
							return (
								<span className="menu-row-content">
									<i className={`bi ${menuIcons[currentId] || 'bi-chevron-right'} menu-row-icon`}></i>
									<span className="menu-row-title">{value}</span>
									{(currentModule === 'submenu') ? <i className="bi bi-chevron-right menu-row-arrow"></i> : null}
								</span>
							);
						default:
							return false;
					}
				}}
				onRowClasses={(item) => (item.id === '__menu-divider__') ? 'menu-divider-row' : ''}
				onLoad={
					() => {
						const submenuItems = [];
						const otherItems = [];
						props.menuSource.forEach(
							function (menu) {
								const item = { id: menu.id, module: menu.module, title: menu.title, href: menu.href };
								if (menu.module === 'submenu') {
									submenuItems.push(item);
								}
								else {
									otherItems.push(item);
								}
							}
						);
						const data = [...submenuItems];
						if (submenuItems.length > 0 && otherItems.length > 0) {
							data.push({ id: '__menu-divider__', module: 'divider', title: '', href: '' });
						}
						data.push(...otherItems);
						return data;
					}
				}
				onRowEdit={(e, rowFields, rowId) => {
					if (rowFields.id === '__menu-divider__') return;
					props.menuClick(rowFields);
				}}
			/>

		</Dialog>
	)
}
